// extracted by mini-css-extract-plugin
export default {"primary":"#9e4b3b","secondary":"#3e4954","success":"#5b9531","info":"#5c84a1","warning":"#f3aa3b","danger":"#cc3227","light":"#f5f5f5","dark":"#212121"};